import { useDispatch } from "react-redux";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { all_routes } from "feature-module/router/all_routes";
import { getExam, getUser } from "utils/userThunk";
import ExamInstructionsModal from "core/common/modal/InstructionsModal";
const StudentDashboard = () => {
  const [student, setStudent] = useState({});
  const userId = localStorage.getItem("_id");
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const navigate = useNavigate()
  const [open, setOpen] = useState(false); // show modal on load
  const [selectedExamType, setSelectedExamType] = useState("");


  const handleAgree = () => {
    setOpen(false);
    setShowModal(true);
    // TODO: start the exam here (e.g., route to /exam or unlock UI)
  };
  useEffect(() => {
    dispatch(getUser({ userId })).then((res) =>
      setStudent(res?.payload?.user || {})
    );
  }, [userId]);
  const handleStartQuiz = () => {
    setOpen(true)
  };
  const handleProceed = async () => {
    if (!selectedLanguage) {
      alert("Please select a language.");
      return;
    }
    const result = await dispatch(getUser({}));
    if (getUser.fulfilled.match(result)) {
      const user = result.payload.user;
      console.log("Fetched user:", user);
      // Find the paid application from CSA or Housekeeping
      const paidCSA = user.csa_applications?.find(app => app.status === "paid");
      const paidHousekeeping = user.housekeeping_applications?.find(app => app.status === "paid");
      const paidApplication = paidCSA || paidHousekeeping;
      if (!paidApplication) {
        console.error("No paid application found");
        alert("No paid application found for this user.");
        return;
      }
      console.log("Paid application:", paidApplication);
      const query = new URLSearchParams({
        language: selectedLanguage,
        // examType: paidApplication?.apply_for,
        userId: localStorage._id
      }).toString();
      window.open(`${all_routes.studentQuiz}?${query}`, '_blank');
    } else {
      console.log(result?.payload)
      throw new Error(result.payload?.message || "Failed to fetch user");
    }
    console.log("Selected language:", selectedLanguage);
    setShowModal(false);
  };
  return (
    <>
      <Breadcrumb title="Dashboard" />
      <div className="content" style={{ minHeight: "100vh" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-end">
              <button
                className="btn mb-4 bg-primary text-white"
                style={{fontSize:"16px"}}
                onClick={handleStartQuiz}
              >
                Start Exam
              </button>
            </div>
          </div>
          {/* Student Info Card */}
          <div className="row">
            <div className="col-lg-12">
              <div className="card p-4 d-flex flex-lg-row flex-column align-items-center mb-6 align-lg-items-start">
                <div className="mb-3 mb-md-0 me-md-4 col-lg-3 text-center">
                  <img
                    src={
                      localStorage.getItem("image") ||
                      "https://secure.gravatar.com/avatar/87cff3ad6a241cb35b7edd6abbd319b2?s=96&d=mm&r=g"
                    }
                    alt="Img"
                    className="img-fluid rounded-circle"
                    style={{ width: 80, height: 80 }}
                  />
                  <h5 className="mt-2 mb-1">
                    {student?.first_name + " " + student?.last_name}
                  </h5>
                  <p className="mb-1">
                    Reg. No : {student?.registration_number ? student.registration_number : "NA"}
                  </p>
                  <p className="fw-bold mb-1">Payment Status:</p>
                  <p>
                    {student?.housekeeping_applications?.some(app => app.status === "paid") &&
                      "Housekeeping: Paid "}
                    {student?.housekeeping_applications?.some(app => app.status === "paid") &&
                      student?.csa_applications?.some(app => app.status === "paid") &&
                      " / "}
                    {student?.csa_applications?.some(app => app.status === "paid") &&
                      "CSA: Paid"}
                  </p>
                </div>
                <div className="flex-grow-1 w-100 col-lg-9 col-md-12 ">
                  <div className="row mt-10 mt-lg-0 mx-auto">
                    <div className="col-md-6 mb-3">
                      <div className="text-muted">Father’s Name</div>
                      <div className="fw-bold">{student?.father_husband_name || "-"}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="text-muted">Mother’s Name</div>
                      <div className="fw-bold" style={{ width: "300px" }}>{student?.mother_name || "-"}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="text-muted">Mobile Number</div>
                      <div className="fw-bold">{student?.phone || "-"}</div>
                    </div>
                    <div className="col-md-6 mb-3" style={{ width: "300px" }}>
                      <div className="text-muted">Address</div>
                      <div className="fw-bold text-wrap">
                        {student?.present_village &&
                          student?.present_district &&
                          student?.present_state &&
                          student?.present_pincode ? (
                          `${student.present_village}, ${student.present_district}, ${student.present_state}, ${student.present_pincode}`
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="text-muted">Email ID</div>
                      <div className="fw-bold">{student?.email || "-"}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="text-muted">Applied For</div>
                      <div className="fw-bold">
                        {student?.housekeeping_applications?.some(app => app.status === "paid") && "Housekeeping"}
                        {student?.housekeeping_applications?.some(app => app.status === "paid") &&
                          student?.csa_applications?.some(app => app.status === "paid") && " / "}
                        {student?.csa_applications?.some(app => app.status === "paid") && "CSA"}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* :point_down: Language Selection Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Please Select Your Language</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="fw-bold">कृपया अपनी भाषा का चयन करें</p>
          <div className="d-flex justify-content-center gap-4 my-3">
            <Button
              variant={selectedLanguage === "hindi" ? "primary" : "outline-primary"}
              onClick={() => {
                setSelectedLanguage("hindi")
                localStorage.setItem("selectedLanguage", "hindi")
              }}
            >
              Hindi
            </Button>
            <Button
              variant={selectedLanguage === "english" ? "primary" : "outline-primary"}
              onClick={() => {
                setSelectedLanguage("english")
                localStorage.setItem("selectedLanguage", "english")
              }}
            >
              English
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="mx-2" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleProceed}>
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>
      <ExamInstructionsModal open={open}
        onAgree={handleAgree}
        onClose={() => setOpen(false)} />
    </>
  );
};
export default StudentDashboard;